const defaultAnimationShow = {
    show: {
        type: "fadeIn"
    }
};
const defaultAnimation = {
    ...defaultAnimationShow,
    hide: { type: "fade", to: 0 }
};
export const defaultAnimationWithHidingSmooth = {
    ...defaultAnimationShow,
    hide: { type: "fadeOut", duration: 200, delay: 180 }
};
export default (popoverRef, animation = defaultAnimation, animationWithHidingSmooth = defaultAnimationWithHidingSmooth) => (e) => {
    var _a, _b;
    if (!((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.instance))
        return;
    const { instance } = popoverRef.current;
    if (instance.option("visible")) {
        if (e) {
            if ("event" in e) {
                (_b = e.event) === null || _b === void 0 ? void 0 : _b.stopPropagation();
            }
            else if ("stopPropagation" in e) {
                e.stopPropagation();
            }
        }
        instance.option("animation", animation);
        instance.hide();
    }
    else {
        instance.option("animation", animationWithHidingSmooth);
    }
};
